import './pranzi/style';
import FormStructure from './pranzi/form_structure';

export default FormStructure;